import { tourId } from 'utils/constants';

export const urlTemplates = {
  config: '/feeds/config.json',
  trans: '/feeds/translations/trans_en.json',
  athletes: '/feeds/athletes/athletes.json',
  submitVote: '/apis/services/Gameplay/submit-vote',
  fanLogin: '/apis/services/session/fan-login',
  mediaLogin: '/apis/services/session/media-login',
  federationLogin: '/apis/services/session/country-login',
  getVotes: '/apis/services/Gameplay/{{guid}}/get-votes',
  getResults: '/apis/services/Gameplay/{{guid}}/get-results',
  getStatus: '/feeds/status/gamestatus.json',
  fixtures: '/feeds/fixtures/fixtures_1_en.json',
  constraints: '/feeds/limits/constraints_1_1.json',
  playerLists: '/feeds/players/players_1_en_{gamedayId}.json',
  createTeam: '/user/team',
  postLogin: '/user/web-login',
  webviewLogin: '/user/login',
  getGamerCard: '/user/{{guid}}/game-card',
  getUserPhaseWisePlayers: '/user/{{guid}}/phase-wise-players',
  getUserCreatedTeam: '/user/{{guid}}/team',
  getTeamCreatedGamedays: '/user/{{guid}}/gamedays',
  getTeamNameValidate: '/user/{{guid}}/validate-team-Name',
  getGlobalRank: '/user/{{guid}}/global-rank', //self rank
  getMatchLBLive: '/feeds/leaderboards/global_lb_live_{gamedayId}.json', //live: matchstatus - 4 stop calling this
  getMatchLB: '/feeds/leaderboards/global_lb_{gamedayId}.json',
  otherUserTeam: '/user/{{guid}}/lb-team',
  getLBMatchesFliter: '/feeds/leaderboards/filter_1.json',
  getmixApi: '/feeds/live/mixapi/mixapi_1.json',
  playerCardsFixture: `/feeds/stats/PlayerCardsFixture_${tourId}_{PlayerId}.json`,
  playerCardsStats: `/feeds/stats/PlayerCardsStats_${tourId}_{PlayerId}_{gamedayId}.json`,
  getOverviewTeam: '/user/{{guid}}/team/overview'
};
